<div class="custom-loader" [class.active]="transitionService.showGameLoader$ | async">
    <div class="loader">
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
        <div class="bar4"></div>
        <div class="bar5"></div>
        <div class="bar6"></div>

        <p class="loader-message">{{transitionService.gameLoaderMessage$ | async}}</p>
    </div>
</div>